import { Ng2StateDeclaration } from "@uirouter/angular";
import { WorkGroupsComponent } from "./workgroups/work-groups.component";
import { WorkGroupComponent } from "./workgroups/work-group.component";
import { EditWorkGroupComponent } from "./workgroups/work-group.edit.component";
import { WorkGroupsDataService } from "../core/workgroups.dataservice";
import { WorkplaceDataService } from "../core/workplaces.dataservice";
import { PersonDataService } from "../core/persons.dataservice";

export const resourcesState: Ng2StateDeclaration = {
    name: "app.resources",
    url: "/resources",
    abstract: true
};

export const workGroupsState: Ng2StateDeclaration = {
    name: "app.resources.workgroups",
    url: "/workgroups",
    views: {
        "main-view@app": {
            component: WorkGroupsComponent
        }
    },
    resolve: {
        workGroups: [WorkGroupsDataService.Id, function (workGroupsDataService: WorkGroupsDataService) {
            return workGroupsDataService.getAll();
        }],
        workplaces: [WorkplaceDataService.Id, function (workGroupsDataService: WorkplaceDataService) {
            return workGroupsDataService.getAll();
        }]
    }
};

export const workGroupState: Ng2StateDeclaration = {
    name: "app.resources.workgroups.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: WorkGroupComponent
        }
    },
    resolve: {
        workGroup: [WorkGroupsDataService.Id, "$stateParams", function (workGroupsDataService: WorkGroupsDataService, $stateParams) {
            return workGroupsDataService.get($stateParams.id);
        }],
        workplaces: [WorkplaceDataService.Id, function (workGroupsDataService: WorkplaceDataService) {
            return workGroupsDataService.getAll();
        }],
        persons: [PersonDataService.Id, function (personDataService: PersonDataService) {
            return personDataService.getAll();
        }]
    }
};

export const editWorkGroupState: Ng2StateDeclaration = {
    name: "app.resources.workgroups.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditWorkGroupComponent
        }
    },
    resolve: {
        isNew: function () {
            return false;
        },
        workGroup: [WorkGroupsDataService.Id, "$stateParams", function (workGroupsDataService: WorkGroupsDataService, $stateParams) {
            return workGroupsDataService.get($stateParams.id);
        }],
        workplaces: [WorkplaceDataService.Id, function (workGroupsDataService: WorkplaceDataService) {
            return workGroupsDataService.getAll();
        }],
        persons: [PersonDataService.Id, function (personDataService: PersonDataService) {
            return personDataService.getAll();
        }]
    }
};

export const newWorkGroupState: Ng2StateDeclaration = {
    name: "app.resources.workgroups.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditWorkGroupComponent
        }
    },
    resolve: {
        isNew: function () {
            return true;
        },
        workGroup: [function () {
            return <Nema.Crew.Model.WorkGroup>{
                Name: "",
                SortTag: "",
                Description: "",
                Color: "",
                WorkGroupPersons: [],
                Active: true
            };
        }],
        workplaces: [WorkplaceDataService.Id, function (workGroupsDataService: WorkplaceDataService) {
            return workGroupsDataService.getAll();
        }],
        persons: [PersonDataService.Id, function (personDataService: PersonDataService) {
            return personDataService.getAll();
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/resources.states.ts